<template>
  <div class="popbox">
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item prop="phone" label-width="80px" label="手机：">
        <el-input
          AUTOCOMPLETE="off"
          v-model="form.phone"
          placeholder="请输入手机号"
          auto-complete="new-password"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        class="form-item"
        prop="code"
        label-width="80px"
        label="验证码："
      >
        <el-input
          v-model="form.code"
          placeholder="请输入短信验证码"
          auto-complete="new-password"
        >
          <div
            class="verification-class"
            v-if="isShow"
            @click="verification"
            slot="append"
          >
            获取验证码
          </div>
          <div v-else slot="append">{{ count }}秒后再获取</div>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')" class="loginbutton"
          >提&nbsp;交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
  <script>
  import { mapActions,mapGetters } from 'vuex';
export default {
  components: {},
  data() {

    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    var validatorCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("验证码不能为空"));
      } else {
        callback();
      }
    };
    return {
      form: {
        phone: "",
        code: "",
      },
      rules: {
        phone: [{ validator: validatorPhone, trigger: "blur" }],
        code: [{ validator: validatorCode, trigger: "blur" }],
      },
      isShow: true,
      count: 0,
    };
  },

  mounted() {},
  methods: {
    ...mapActions(['saveUserPhone']),
    verification() {
      this.sendCode();
    },

    //发送验证码
    sendCode() {
      let info = {};
      info.phone = this.form.phone;
      var reg_tel3 = /^1\d{10}$/;
      if (!reg_tel3.test(info.phone)) {
        this.$FUnitls.showInfo("请输入正确的手机号", "info");
        return false;
      }
      this.$api.user.sendCode(info).then((res) => {
        if (res.data.errno == 0) {
          this.$FUnitls.showInfo("发送成功", "info");
          this.countdown();
        } else {
          this.$FUnitls.showInfo(res.data.msg, "info");
        }
      });
    },

    countdown() {
      this.isShow = false; //倒计时
      // this.visShow = true;
      this.count = 60; //赋值60秒
      var times = setInterval(() => {
        this.count--; //递减
        if (this.count <= 0) {
          // <=0 变成获取按钮
          this.isShow = true;
          clearInterval(times);
        }
      }, 1000); //1000毫秒后执行
    },

    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //绑定手机
          this.binDing()
        } else {
          return false;
        }
      });
    },

    overBing(){
      //更新绑定的手机号
      this.saveUserPhone(this.form.phone)
    },

    binDing() {
      let info = {};
      info.type = 1;
      info.phone = this.form.phone;
      info.code = this.form.code;
      this.$api.user.binDing(info).then((res) => {
        if (res.data.errno == 0) {
          this.$FUnitls.showInfo("绑定成功", "success", this.overBing);
        } else {
          this.$FUnitls.showInfo(res.data.errmsg, "error");
        }
      });
    },
  },
};
</script>
  <!--声明语言，并且添加scoped-->
<style  scoped>
.verification-class {
  cursor: pointer;
}

.form-item {
  margin-bottom: 48px;
}
.popbox >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
  -webkit-text-fill-color: #666 !important;
}

.popbox >>> .el-input--prefix .el-input__inner {
  color: #666;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}
.popbox >>> .el-input__inner {
  border: none;
  border-bottom: 1px solid #e6e6e6 !important;
  border-radius: 0;
}

.popbox >>> .el-form-item.is-error .el-input__inner,
.popbox >>> .el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.popbox >>> .el-input--prefix .iconfont.icon-shouji {
  font-size: 28px;
}
.popbox >>> .el-input-group__append,
.popbox >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.popbox >>> .el-form-item__content {
  text-align: center;
}
.popbox >>> .el-form-item__label {
  font-size: 16px;
  color: #666;
}
.popbox >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.popbox >>> .el-input__prefix {
  padding-top: 2px;
}
.popbox >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}
.popbox >>> .loginbutton {
  width: 85px;
  font-size: 16px;
}
.popbox >>> .el-checkbox__label {
  color: #fff;
}
.popbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.popbox >>> .el-button {
  border-radius: 26px;
  padding: 8px 28px;
}
.popbox >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.popbox >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.popbox >>> .el-checkbox__inner {
  border-radius: 7px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/user/PopupPhone.vue